import React from 'react';

import './chat-avatar.scss';

const ChatAvatar = ({ avatarUrl }) => <div className='chat-avatar' style={{ backgroundImage: `url(${avatarUrl})` }} />;

export default ChatAvatar;
